/**
 *
 * @param {string} name
 * @returns
 */

import key from "./key"

const url = `app/${key}`

export const LOAD_RECORD_QUOTATION_DETAILS = `${url}/LOAD_RECORD_QUOTATION_DETAILS`
export const LOAD_RECORD_QUOTATION_DETAILS_SUCCESS = `${url}/LOAD_RECORD_QUOTATION_DETAILS_SUCCESS`
export const LOAD_RECORD_QUOTATION_DETAILS_ERROR = `${url}/LOAD_RECORD_QUOTATION_DETAILS _ERROR`
export const CREATE_QUOTATION_RECORD = `${url}/CREATE_QUOTATION_RECORD`
export const CREATE_QUOTATION_RECORD_SUCCESS = `${url}/CREATE_QUOTATION_RECORD_SUCCESS`
export const CREATE_QUOTATION_RECORD_ERROR = `${url}/CREATE_QUOTATION_RECORD_ERROR`
export const UPDATE_QUOTATION_RECORD = `${url}/UPDATE_QUOTATION_RECORD`
export const UPDATE_QUOTATION_RECORD_SUCCESS = `${url}/UPDATE_QUOTATION_RECORD_SUCCESS`
export const UPDATE_QUOTATION_RECORD_ERROR = `${url}/UPDATE_QUOTATION_RECORD_ERROR`
export const DELETE_QUOTATION_RECORD = `${url}/DELETE_QUOTATION_RECORD`
export const DELETE_QUOTATION_RECORD_SUCCESS = `${url}/DELETE_QUOTATION_RECORD_SUCCESS`
export const DELETE_QUOTATION_RECORD_ERROR = `${url}/DELETE_QUOTATION_RECORD_ERROR`

//Deliverable action types
export const LOAD_DELIVERABLE_DETAILS = `${url}/LOAD_DELIVERABLE_DETAILS`
export const LOAD_DELIVERABLE_DETAILS_SUCCESS = `${url}/LOAD_DELIVERABLE_DETAILS_SUCCESS`
export const LOAD_DELIVERABLE_DETAILS_ERROR = `${url}/LOAD_DELIVERABLE_DETAILS _ERROR`
export const CREATE_DELIVERABLE = `${url}/CREATE_DELIVERABLE`
export const CREATE_DELIVERABLE_SUCCESS = `${url}/CREATE_DELIVERABLE_SUCCESS`
export const CREATE_DELIVERABLE_ERROR = `${url}/CREATE_DELIVERABLE_ERROR`
export const UPDATE_DELIVERABLE = `${url}/UPDATE_DELIVERABLE`
export const UPDATE_DELIVERABLE_SUCCESS = `${url}/UPDATE_DELIVERABLE_SUCCESS`
export const UPDATE_DELIVERABLE_ERROR = `${url}/UPDATE_DELIVERABLE_ERROR`
export const DELETE_DELIVERABLE = `${url}/DELETE_DELIVERABLE`
export const DELETE_DELIVERABLE_SUCCESS = `${url}/DELETE_DELIVERABLE_SUCCESS`
export const DELETE_DELIVERABLE_ERROR = `${url}/DELETE_DELIVERABLE_ERROR`
export const LOAD_RECORDS_META_DATA = `${url}/LOAD_RECORDS_META_DATA`
export const LOAD_RECORDS_META_DATA_SUCCESS = `${url}/LOAD_RECORDS_META_DATA_SUCCESS`
export const LOAD_RECORDS_META_DATA_ERROR = `${url}/LOAD_RECORDS_META_DATA_ERROR`

export const LOAD_DELIVERABLES_RECORDS_META_DATA = `${url}/LOAD_DELIVERABLES_RECORDS_META_DATA`
export const LOAD_DELIVERABLES_RECORDS_META_DATA_SUCCESS = `${url}/LOAD_DELIVERABLES_RECORDS_META_DATA_SUCCESS`
export const LOAD_DELIVERABLES_RECORDS_META_DATA_ERROR = `${url}/LOAD_DELIVERABLES_RECORDS_META_DATA_ERROR`

export const LOAD_INSTRUCTIONS_RECORDS_META_DATA = `${url}/LOAD_INSTRUCTIONS_RECORDS_META_DATA`
export const LOAD_INSTRUCTIONS_RECORDS_META_DATA_SUCCESS = `${url}/LOAD_INSTRUCTIONS_RECORDS_META_DATA_SUCCESS`
export const LOAD_INSTRUCTIONS_RECORDS_META_DATA_ERROR = `${url}/LOAD_INSTRUCTIONS_RECORDS_META_DATA_ERROR`

export const LOAD_RECORDS_VALID_CACHE = `${url}/LOAD_RECORDS_VALID_CACHE`
//Special Instructions
export const LOAD_VALUE_INSERT = `${url}/LOAD_VALUE_INSERT`
export const LOAD_VALUE_INSERT_SUCCESS = `${url}/LOAD_VALUE_INSERT_SUCCESS`
export const LOAD_VALUE_INSERT_ERROR = `${url}/LOAD_VALUE_INSERT _ERROR`
export const CREATE_VALUE_INSERT = `${url}/CREATE_VALUE_INSERT`
export const CREATE_VALUE_INSERT_SUCCESS = `${url}/CREATE_VALUE_INSERT_SUCCESS`
export const CREATE_VALUE_INSERT_ERROR = `${url}/CREATE_VALUE_INSERT_ERROR`
export const UPDATE_VALUE_INSERT = `${url}/UPDATE_VALUE_INSERT`
export const UPDATE_VALUE_INSERT_SUCCESS = `${url}/UPDATE_VALUE_INSERT_SUCCESS`
export const UPDATE_VALUE_INSERT_ERROR = `${url}/UPDATE_VALUE_INSERT_ERROR`
export const DELETE_VALUE_INSERT = `${url}/DELETE_VALUE_INSERT`
export const DELETE_VALUE_INSERT_SUCCESS = `${url}/DELETE_VALUE_INSERT_SUCCESS`
export const DELETE_VALUE_INSERT_ERROR = `${url}/DELETE_VALUE_INSERT_ERROR`

//Expiry date
export const UPDATE_EXPIRY_DATE = `${url}/UPDATE_EXPIRY_DATE`
export const UPDATE_EXPIRY_DATE_SUCCESS = `${url}/UPDATE_EXPIRY_DATE_SUCCESS`
export const UPDATE_EXPIRY_DATE_ERROR = `${url}/UPDATE_EXPIRY_DATE_ERROR`

//Special Instructions
export const LOAD_INSTRUCTIONS = `${url}/LOAD_INSTRUCTIONS`
export const LOAD_INSTRUCTIONS_SUCCESS = `${url}/LOAD_INSTRUCTIONS_SUCCESS`
export const LOAD_INSTRUCTIONS_ERROR = `${url}/LOAD_INSTRUCTIONS _ERROR`
export const CREATE_INSTRUCTIONS = `${url}/CREATE_INSTRUCTIONS`
export const CREATE_INSTRUCTIONS_SUCCESS = `${url}/CREATE_INSTRUCTIONS_SUCCESS`
export const CREATE_INSTRUCTIONS_ERROR = `${url}/CREATE_INSTRUCTIONS_ERROR`
export const UPDATE_INSTRUCTIONS = `${url}/UPDATE_INSTRUCTIONS`
export const UPDATE_INSTRUCTIONS_SUCCESS = `${url}/UPDATE_INSTRUCTIONS_SUCCESS`
export const UPDATE_INSTRUCTIONS_ERROR = `${url}/UPDATE_INSTRUCTIONS_ERROR`
export const DELETE_INSTRUCTIONS = `${url}/DELETE_INSTRUCTIONS`
export const DELETE_INSTRUCTIONS_SUCCESS = `${url}/DELETE_INSTRUCTIONS_SUCCESS`
export const DELETE_INSTRUCTIONS_ERROR = `${url}/DELETE_INSTRUCTIONS_ERROR`

//Photography EVent list

export const LOAD_PHOTOGRAPHY = `${url}/LOAD_PHOTOGRAPHY`
export const LOAD_PHOTOGRAPHY_SUCCESS = `${url}/LOAD_PHOTOGRAPHY_SUCCESS`
export const LOAD_PHOTOGRAPHY_ERROR = `${url}/LOAD_PHOTOGRAPHY _ERROR`
export const CREATE_PHOTOGRAPHY = `${url}/CREATE_PHOTOGRAPHY`
export const CREATE_PHOTOGRAPHY_SUCCESS = `${url}/CREATE_PHOTOGRAPHY_SUCCESS`
export const CREATE_PHOTOGRAPHY_ERROR = `${url}/CREATE_PHOTOGRAPHY_ERROR`
export const UPDATE_PHOTOGRAPHY = `${url}/UPDATE_PHOTOGRAPHY`
export const UPDATE_PHOTOGRAPHY_SUCCESS = `${url}/UPDATE_PHOTOGRAPHY_SUCCESS`
export const UPDATE_PHOTOGRAPHY_ERROR = `${url}/UPDATE_PHOTOGRAPHY_ERROR`
export const DELETE_PHOTOGRAPHY = `${url}/DELETE_PHOTOGRAPHY`
export const DELETE_PHOTOGRAPHY_SUCCESS = `${url}/DELETE_PHOTOGRAPHY_SUCCESS`
export const DELETE_PHOTOGRAPHY_ERROR = `${url}/DELETE_PHOTOGRAPHY_ERROR`

export const LOAD_SERVICE_DETAILS = `${url}/LOAD_SERVICE_DETAILS`
export const LOAD_SERVICE_DETAILS_SUCCESS = `${url}/LOAD_SERVICE_DETAILS_SUCCESS`
export const LOAD_SERVICE_DETAILS_ERROR = `${url}/LOAD_SERVICE_DETAILS_ERROR`

export const LOAD_SERVICE_ACCOUNT = `${url}/LOAD_SERVICE_ACCOUNT`
export const LOAD_SERVICE_ACCOUNT_SUCCESS = `${url}/LOAD_SERVICE_ACCOUNT_SUCCESS`
export const LOAD_SERVICE_ACCOUNT_ERROR = `${url}/LOAD_SERVICE_ACCOUNT_ERROR`

export const APPROVE_QC_REQUEST = `${url}/APPROVE_QC_REQUEST`
export const APPROVE_QC_REQUEST_SUCCESS = `${url}/APPROVE_QC_REQUEST_SUCCESS`
export const APPROVE_QC_REQUEST_ERROR = `${url}/APPROVE_QC_REQUEST_ERROR`

export const UPDATE_QC_REAPPROVE = `${url}/UPDATE_QC_REAPPROVE`
export const UPDATE_QC_REAPPROVE_SUCCESS = `${url}/UPDATE_QC_REAPPROVE_SUCCESS`
export const UPDATE_QC_REAPPROVE_ERROR = `${url}/UPDATE_QC_REAPPROVE_ERROR`

//Quatation History list
export const LOAD_QUOTATION_HISTORY_DETAILS = `${url}/LOAD_QUOTATION_HISTORY_DETAILS`
export const LOAD_QUOTATION_HISTORY_DETAILS_SUCCESS = `${url}/LOAD_QUOTATION_HISTORY_DETAILS_SUCCESS`
export const LOAD_QUOTATION_HISTORY_DETAILS_ERROR = `${url}/LOAD_QUOTATION_HISTORY_DETAILS_ERROR`

export const LOAD_SALES_APPROVAL = `${url}/LOAD_SALES_APPROVAL`
export const LOAD_SALES_APPROVAL_SUCCESS = `${url}/LOAD_SALES_APPROVAL_SUCCESS`
export const LOAD_SALES_APPROVAL_ERROR = `${url}/LOAD_SALES_APPROVAL_ERROR`

export const LOAD_EMPLOYEE = `${url}/LOAD_EMPLOYEE`
export const LOAD_EMPLOYEE_SUCCESS = `${url}/LOAD_EMPLOYEE_SUCCESS`
export const LOAD_EMPLOYEE_ERROR = `${url}/LOAD_EMPLOYEE_ERROR`

export const LOAD_QC_HISTORY = `${url}/LOAD_QC_HISTORY`
export const LOAD_QC_HISTORY_SUCCESS = `${url}/LOAD_QC_HISTORY_SUCCESS`
export const LOAD_QC_HISTORY_ERROR = `${url}/LOAD_QC_HISTORY_ERROR`

export const LOAD_QC_LAYOUT_MASTER = `${url}/LOAD_QC_LAYOUT_MASTER`
export const LOAD_QC_LAYOUT_MASTER_SUCCESS = `${url}/LOAD_QC_LAYOUT_MASTER_SUCCESS`
export const LOAD_QC_LAYOUT_MASTER_ERROR = `${url}/LOAD_QC_LAYOUT_MASTER_ERROR`
//Quatation Final Submit

export const UPDATE_QUOTATION_LIST = `${url}/UPDATE_QUOTATION_LIST`
export const UPDATE_QUOTATION_LIST_SUCCESS = `${url}/UPDATE_QUOTATION_LIST_SUCCESS`
export const UPDATE_QUOTATION_LIST_ERROR = `${url}/UPDATE_QUOTATION_LIST_ERROR`

export const LOAD_QUOTATION_LIST = `${url}/LOAD_QUOTATION_LIST`
export const LOAD_QUOTATION_LIST_SUCCESS = `${url}/LOAD_QUOTATION_LIST_SUCCESS`
export const LOAD_QUOTATION_LIST_ERROR = `${url}/LOAD_QUOTATION_LIST_ERROR`

export const LOAD_QC_LAYOUT_SEGMENT = `${url}/LOAD_QC_LAYOUT_SEGMENT`
export const LOAD_QC_LAYOUT_SEGMENT_SUCCESS = `${url}/LOAD_QC_LAYOUT_SEGMENT_SUCCESS`
export const LOAD_QC_LAYOUT_SEGMENT_ERROR = `${url}/LOAD_QC_LAYOUT_SEGMENT_ERROR`

//Quotation preview
export const LOAD_QUOTATION_PREVIEW = `${url}/LOAD_QUOTATION_PREVIEW`
export const LOAD_QUOTATION_PREVIEW_SUCCESS = `${url}/LOAD_QUOTATION_PREVIEW_SUCCESS`
export const LOAD_QUOTATION_PREVIEW_ERROR = `${url}/LOAD_QUOTATION_PREVIEW_ERROR`

//Quotation preview
export const UPDATE_QUOTATION_PREVIEW = `${url}/UPDATE_QUOTATION_PREVIEW`
export const UPDATE_QUOTATION_PREVIEW_SUCCESS = `${url}/UPDATE_QUOTATION_PREVIEW_SUCCESS`
export const UPDATE_QUOTATION_PREVIEW_ERROR = `${url}/UPDATE_QUOTATION_PREVIEW_ERROR`

//Add Segment preview
export const ADD_SEGMENT_PREVIEW = `${url}/ADD_SEGMENT_PREVIEW`
export const ADD_SEGMENT_PREVIEW_SUCCESS = `${url}/ADD_SEGMENT_PREVIEW_SUCCESS`
export const ADD_SEGMENT_PREVIEW_ERROR = `${url}/ADD_SEGMENT_PREVIEW_ERROR`

//add crm and product ec deliverable

export const ADD_TEAM_ASSIGN = `${url}/ADD_TEAM_ASSIGN`
export const ADD_TEAM_ASSIGN_SUCCESS = `${url}/ADD_TEAM_ASSIGN_SUCCESS`
export const ADD_TEAM_ASSIGN_ERROR = `${url}/ADD_TEAM_ASSIGN_ERROR`

export const ADD_PRODUCT_ASSIGN = `${url}/ADD_PRODUCT_ASSIGN`
export const ADD_PRODUCT_ASSIGN_SUCCESS = `${url}/ADD_PRODUCT_ASSIGN_SUCCESS`
export const ADD_PRODUCT_ASSIGN_ERROR = `${url}/ADD_PRODUCT_ASSIGN_ERROR`

export const UPDATE_CRM_DELIVER = `${url}/UPDATE_CRM_DELIVER`
export const UPDATE_CRM_DELIVER_SUCCESS = `${url}/UPDATE_CRM_DELIVER_SUCCESS`
export const UPDATE_CRM_DELIVER_ERROR = `${url}/UPDATE_CRM_DELIVER_ERROR`

export const LOAD_EC_DELIVERABLE_DETAILS = `${url}/LOAD_EC_DELIVERABLE_DETAILS`
export const LOAD_EC_DELIVERABLE_DETAILS_SUCCESS = `${url}/LOAD_EC_DELIVERABLE_DETAILS_SUCCESS`
export const LOAD_EC_DELIVERABLE_DETAILS_ERROR = `${url}/LOAD_DELIVERABLE_DETAILS _ERROR`


export const LOAD_DELIVERABLE_EMPLOYEE = `${url}/LOAD_DELIVERABLE_EMPLOYEE`
export const LOAD_DELIVERABLE_EMPLOYEE_SUCCESS = `${url}/LOAD_DELIVERABLE_EMPLOYEE_SUCCESS`
export const LOAD_DELIVERABLE_EMPLOYEE_ERROR = `${url}/LOAD_DELIVERABLE_EMPLOYEE_ERROR`


export const UPDATE_PROCESS = `${url}/UPDATE_PROCESS`
export const UPDATE_PROCESS_SUCCESS = `${url}/UPDATE_PROCESS_SUCCESS`
export const UPDATE_PROCESS_ERROR = `${url}/UPDATE_PROCESS_ERROR`

//Discount Preview

export const UPDATE_DISCOUNT_PREVIEW = `${url}/UPDATE_DISCOUNT_PREVIEW`
export const UPDATE_DISCOUNT_PREVIEW_SUCCESS = `${url}/UPDATE_DISCOUNT_PREVIEW_SUCCESS`
export const UPDATE_DISCOUNT_PREVIEW_ERROR = `${url}/ADD_TEAM_ASSIGN_ERROR`

export const ADD_CRM =`${url}/ADD_CRM`
export const ADD_CRM_SUCCESS=`${url}/ADD_CRM_SUCCESS`
export const ADD_CRM_ERROR =`${url}/ ADD_CRM_ERROR`

export const LOAD_PROCESS_STATUS = `${url}/LOAD_PROCESS_STATUS`
export const LOAD_PROCESS_STATUS_SUCCESS = `${url}/LOAD_PROCESS_STATUS_SUCCESS`
export const LOAD_PROCESS_STATUS_ERROR = `${url}/LOAD_PROCESS_STATUS_ERROR`

const constants = {
  LOAD_RECORDS_VALID_CACHE,
  LOAD_RECORDS_META_DATA,
  LOAD_RECORDS_META_DATA_SUCCESS,
  LOAD_RECORDS_META_DATA_ERROR,
  LOAD_DELIVERABLES_RECORDS_META_DATA,
  LOAD_DELIVERABLES_RECORDS_META_DATA_SUCCESS,
  LOAD_DELIVERABLES_RECORDS_META_DATA_ERROR,
  LOAD_INSTRUCTIONS_RECORDS_META_DATA,
  LOAD_INSTRUCTIONS_RECORDS_META_DATA_SUCCESS,
  LOAD_INSTRUCTIONS_RECORDS_META_DATA_ERROR,
  LOAD_RECORD_QUOTATION_DETAILS,
  LOAD_RECORD_QUOTATION_DETAILS_SUCCESS,
  LOAD_RECORD_QUOTATION_DETAILS_ERROR,

  CREATE_QUOTATION_RECORD,
  CREATE_QUOTATION_RECORD_SUCCESS,
  CREATE_QUOTATION_RECORD_ERROR,
  UPDATE_QUOTATION_RECORD,
  UPDATE_QUOTATION_RECORD_SUCCESS,
  UPDATE_QUOTATION_RECORD_ERROR,
  DELETE_QUOTATION_RECORD,
  DELETE_QUOTATION_RECORD_SUCCESS,
  DELETE_QUOTATION_RECORD_ERROR,
  LOAD_DELIVERABLE_DETAILS,
  LOAD_DELIVERABLE_DETAILS_SUCCESS,
  LOAD_DELIVERABLE_DETAILS_ERROR,

  CREATE_DELIVERABLE,
  CREATE_DELIVERABLE_SUCCESS,
  CREATE_DELIVERABLE_ERROR,
  UPDATE_DELIVERABLE,
  UPDATE_DELIVERABLE_SUCCESS,
  UPDATE_DELIVERABLE_ERROR,
  DELETE_DELIVERABLE,
  DELETE_DELIVERABLE_SUCCESS,
  DELETE_DELIVERABLE_ERROR,

  LOAD_VALUE_INSERT,
  LOAD_VALUE_INSERT_SUCCESS,
  LOAD_VALUE_INSERT_ERROR,
  CREATE_VALUE_INSERT,
  CREATE_VALUE_INSERT_SUCCESS,
  CREATE_VALUE_INSERT_ERROR,
  UPDATE_VALUE_INSERT,
  UPDATE_VALUE_INSERT_SUCCESS,
  UPDATE_VALUE_INSERT_ERROR,
  DELETE_VALUE_INSERT,
  DELETE_VALUE_INSERT_SUCCESS,
  DELETE_VALUE_INSERT_ERROR,
  
  CREATE_INSTRUCTIONS,
  CREATE_INSTRUCTIONS_SUCCESS,
  CREATE_INSTRUCTIONS_ERROR,
  UPDATE_INSTRUCTIONS,
  UPDATE_INSTRUCTIONS_SUCCESS,
  UPDATE_INSTRUCTIONS_ERROR,
  DELETE_INSTRUCTIONS,
  DELETE_INSTRUCTIONS_SUCCESS,
  DELETE_INSTRUCTIONS_ERROR,
  LOAD_INSTRUCTIONS,
  LOAD_INSTRUCTIONS_SUCCESS,
  LOAD_INSTRUCTIONS_ERROR,

  UPDATE_EXPIRY_DATE,
  UPDATE_EXPIRY_DATE_SUCCESS,
  UPDATE_EXPIRY_DATE_ERROR,

  CREATE_PHOTOGRAPHY,
  CREATE_PHOTOGRAPHY_SUCCESS,
  CREATE_PHOTOGRAPHY_ERROR,
  UPDATE_PHOTOGRAPHY,
  UPDATE_PHOTOGRAPHY_SUCCESS,
  UPDATE_PHOTOGRAPHY_ERROR,
  DELETE_PHOTOGRAPHY,
  DELETE_PHOTOGRAPHY_SUCCESS,
  DELETE_PHOTOGRAPHY_ERROR,
  LOAD_PHOTOGRAPHY,
  LOAD_PHOTOGRAPHY_SUCCESS,
  LOAD_PHOTOGRAPHY_ERROR,

  LOAD_SERVICE_DETAILS,
  LOAD_SERVICE_DETAILS_SUCCESS,
  LOAD_SERVICE_DETAILS_ERROR,

  LOAD_SERVICE_ACCOUNT,
  LOAD_SERVICE_ACCOUNT_SUCCESS,
  LOAD_SERVICE_ACCOUNT_ERROR,

  LOAD_SALES_APPROVAL,
  LOAD_SALES_APPROVAL_SUCCESS,
  LOAD_SALES_APPROVAL_ERROR,

  LOAD_EMPLOYEE,
  LOAD_EMPLOYEE_SUCCESS,
  LOAD_EMPLOYEE_ERROR,

  LOAD_QC_HISTORY,
  LOAD_QC_HISTORY_SUCCESS,
  LOAD_QC_HISTORY_ERROR,

  APPROVE_QC_REQUEST,
  APPROVE_QC_REQUEST_SUCCESS,
  APPROVE_QC_REQUEST_ERROR,

  UPDATE_QC_REAPPROVE,
  UPDATE_QC_REAPPROVE_SUCCESS,
  UPDATE_QC_REAPPROVE_ERROR,

  LOAD_QUOTATION_HISTORY_DETAILS,
  LOAD_QUOTATION_HISTORY_DETAILS_SUCCESS,
  LOAD_QUOTATION_HISTORY_DETAILS_ERROR,

  LOAD_QC_LAYOUT_MASTER,
  LOAD_QC_LAYOUT_MASTER_SUCCESS,
  LOAD_QC_LAYOUT_MASTER_ERROR,

  UPDATE_QUOTATION_LIST,
  UPDATE_QUOTATION_LIST_SUCCESS,
  UPDATE_QUOTATION_LIST_ERROR,

  LOAD_QUOTATION_LIST,
  LOAD_QUOTATION_LIST_SUCCESS,
  LOAD_QUOTATION_LIST_ERROR,

  LOAD_QC_LAYOUT_SEGMENT,
  LOAD_QC_LAYOUT_SEGMENT_SUCCESS,
  LOAD_QC_LAYOUT_SEGMENT_ERROR,

  LOAD_QUOTATION_PREVIEW,
  LOAD_QUOTATION_PREVIEW_SUCCESS,
  LOAD_QUOTATION_PREVIEW_ERROR,

  UPDATE_QUOTATION_PREVIEW,
  UPDATE_QUOTATION_PREVIEW_SUCCESS,
  UPDATE_QUOTATION_PREVIEW_ERROR,

  ADD_SEGMENT_PREVIEW,
  ADD_SEGMENT_PREVIEW_SUCCESS,
  ADD_SEGMENT_PREVIEW_ERROR,

  ADD_PRODUCT_ASSIGN,
  ADD_PRODUCT_ASSIGN_SUCCESS,
  ADD_PRODUCT_ASSIGN_ERROR,

  ADD_TEAM_ASSIGN,
  ADD_TEAM_ASSIGN_SUCCESS,
  ADD_TEAM_ASSIGN_ERROR,

  UPDATE_CRM_DELIVER,
  UPDATE_CRM_DELIVER_SUCCESS,
  UPDATE_CRM_DELIVER_ERROR,

  LOAD_EC_DELIVERABLE_DETAILS,
  LOAD_EC_DELIVERABLE_DETAILS_SUCCESS,
  LOAD_EC_DELIVERABLE_DETAILS_ERROR,

  LOAD_DELIVERABLE_EMPLOYEE,
  LOAD_DELIVERABLE_EMPLOYEE_SUCCESS,
  LOAD_DELIVERABLE_EMPLOYEE_ERROR,

  //Discount preview
  UPDATE_DISCOUNT_PREVIEW,
  UPDATE_DISCOUNT_PREVIEW_SUCCESS,
  UPDATE_DISCOUNT_PREVIEW_ERROR,

  UPDATE_PROCESS,
  UPDATE_PROCESS_SUCCESS,
  UPDATE_PROCESS_ERROR,

  ADD_CRM,
  ADD_CRM_SUCCESS,
  ADD_CRM_ERROR,

  LOAD_PROCESS_STATUS,
  LOAD_PROCESS_STATUS_SUCCESS,
  LOAD_PROCESS_STATUS_ERROR
  
}

export default constants
